import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

type DropdownData = [string, [string, number[]][]][];

interface DropdownContainerProps {
  id: string;
  dropdownData: DropdownData;
  onFirstDropdownChange?: (key: string, value: string) => void; // Handler for first dropdown
  onSecondDropdownChange?: (key: string, value: string) => void; // Handler for second dropdown
}

export const DropdownContainer: React.FC<DropdownContainerProps> = ({
  id,
  dropdownData,
  onFirstDropdownChange,
  onSecondDropdownChange,
}) => {
  const dropdownKey = id;
  const [, dropdownContent] = dropdownData[0];
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [subOptions, setSubOptions] = useState<number[]>([]);
  const [selectedSubOption, setSelectedSubOption] = useState<number | ''>('');

  useEffect(() => {
    const selectedCategoryData = dropdownContent.find(
      ([category]) => category === selectedCategory,
    );
    if (selectedCategoryData) {
      setSubOptions(selectedCategoryData[1]);
    } else {
      setSubOptions([]);
    }

    setSelectedSubOption('');
  }, [selectedCategory, dropdownContent]);

  const handleFirstDropdownChange = (value: string) => {
    setSelectedCategory(value);
    if (onFirstDropdownChange) {
      onFirstDropdownChange(dropdownKey + '-0', value);
    }
    if (onSecondDropdownChange) {
      onSecondDropdownChange(dropdownKey + '-2', '');
    }
  };

  const handleSecondDropdownChange = (value: number) => {
    setSelectedSubOption(value);
    if (onSecondDropdownChange) {
      onSecondDropdownChange(dropdownKey + '-2', value.toString());
    }
  };

  return (
    <div className="dropdown-container">
      <FormControl fullWidth className="dropdown-item">
        <InputLabel id="first-dropdown-label">Region</InputLabel>
        <Select
          labelId="first-dropdown-label"
          id={dropdownKey + '-0'}
          value={selectedCategory}
          onChange={(e) => handleFirstDropdownChange(e.target.value as string)}
        >
          <MenuItem key={999} value={''}>
            All Regions
          </MenuItem>
          {dropdownContent.map(([category]) => (
            <MenuItem key={category} value={category}>
              {category}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth className="dropdown-item">
        <InputLabel id="second-dropdown-label">Plume</InputLabel>
        <Select
          labelId="second-dropdown-label"
          id={dropdownKey + '-2'}
          value={selectedSubOption}
          onChange={(e) => handleSecondDropdownChange(Number(e.target.value))}
        >
          <MenuItem key={999} value={''}>
            All Plumes
          </MenuItem>
          {subOptions.map((subOption) => (
            <MenuItem key={subOption} value={subOption}>
              {subOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};
